<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="p-24">
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions class="p-24 p-t-0">
  <button mat-flat-button color="primary" (click)="onCancel()">{{ data.cancelButtonText }}</button>
  <button mat-flat-button color="warn" (click)="onConfirm()">{{ data.confirmButtonText }}</button>
</mat-dialog-actions>
